export const getStartedSvg = "/images/GetStarted.svg";
export const thankYouCompletedSvg = "/images/ThankYouCompleted.svg";
export const verifyIdSvg = "/images/VerifyId.svg";
export const emrErrorSvg = "/images/EMRError.svg";
export const portalLoginSvg = "/images/PortalLogin.svg";
export const portalWelcomeSvg = "/images/PortalWelcome.svg";
export const timeoutSvg = "/images/Timeout.svg";
export const marbleLogoSvg = "/images/MarbleLogo.svg";
export const navBarLogoSvg = "/images/NavBarLogo.svg";
export const appsTitleImageSvg = "/images/AppsTitleImage.svg";
export const dataTitleImageSvg = "/images/DataTitleImage.svg";
export const giveUsAMomentSvg = "/images/GiveUsAMoment.svg";
export const marbleTextLogoSvg = "/images/MarbleTextLogo.svg";
